import React from 'react';
import Header from '../../components/Header/Header';
import Card from '../../components/Card/Card';
import './About.css';

const About = ({ onGoHome, onNavigate }) => {
  return (
    <div className="about-page">
      <Header onLogoClick={onGoHome} onNavigate={onNavigate} />
      <main className="about-main">
        <div className="about-container">
          {/* Hero Section */}
          <section className="about-hero">
            <h1 className="about-hero__title">About RezHolidays</h1>
            <p className="about-hero__subtitle">
              Your trusted partner for luxury hotel bookings worldwide
            </p>
          </section>

          {/* Mission Section */}
          <section className="about-section">
            <Card variant="elevated" className="about-card">
              <div className="about-card__content">
                <h2 className="about-card__title">Our Mission</h2>
                <p className="about-card__text">
                  At RezHolidays, we believe that every journey deserves an exceptional stay. 
                  Our mission is to connect travelers with the world's finest hotels, offering 
                  unparalleled service, competitive prices, and unforgettable experiences. We're 
                  committed to making luxury travel accessible while maintaining the highest 
                  standards of quality and customer satisfaction.
                </p>
              </div>
            </Card>
          </section>

          {/* Values Section */}
          <section className="about-section">
            <h2 className="about-section__title">Our Values</h2>
            <div className="about-values">
              <Card variant="elevated" className="about-value-card">
                <div className="about-value-card__icon">✨</div>
                <h3 className="about-value-card__title">Excellence</h3>
                <p className="about-value-card__text">
                  We curate only the finest hotels and ensure every booking meets our high standards.
                </p>
              </Card>
              
              <Card variant="elevated" className="about-value-card">
                <div className="about-value-card__icon">🤝</div>
                <h3 className="about-value-card__title">Trust</h3>
                <p className="about-value-card__text">
                  Your security and satisfaction are our top priorities. We protect your data and honor our commitments.
                </p>
              </Card>
              
              <Card variant="elevated" className="about-value-card">
                <div className="about-value-card__icon">🌍</div>
                <h3 className="about-value-card__title">Global Reach</h3>
                <p className="about-value-card__text">
                  From bustling cities to serene beaches, we offer hotels in destinations worldwide.
                </p>
              </Card>
              
              <Card variant="elevated" className="about-value-card">
                <div className="about-value-card__icon">💎</div>
                <h3 className="about-value-card__title">Luxury</h3>
                <p className="about-value-card__text">
                  We specialize in premium accommodations that provide comfort, elegance, and exceptional service.
                </p>
              </Card>
            </div>
          </section>

          {/* Story Section */}
          <section className="about-section">
            <Card variant="elevated" className="about-card">
              <div className="about-card__content">
                <h2 className="about-card__title">Our Story</h2>
                <p className="about-card__text">
                  Founded with a passion for travel and hospitality, RezHolidays began as a 
                  vision to simplify luxury hotel bookings. What started as a small team of 
                  travel enthusiasts has grown into a trusted platform serving thousands of 
                  travelers worldwide.
                </p>
                <p className="about-card__text">
                  Today, we partner with over 10,000 hotels across 150+ countries, offering 
                  everything from boutique city hotels to exclusive beachfront resorts. Our 
                  dedicated team works around the clock to ensure your booking experience is 
                  seamless and your stay is memorable.
                </p>
              </div>
            </Card>
          </section>

          {/* Stats Section */}
          <section className="about-section">
            <div className="about-stats">
              <div className="about-stat">
                <div className="about-stat__number">10,000+</div>
                <div className="about-stat__label">Hotels Worldwide</div>
              </div>
              <div className="about-stat">
                <div className="about-stat__number">150+</div>
                <div className="about-stat__label">Countries</div>
              </div>
              <div className="about-stat">
                <div className="about-stat__number">500K+</div>
                <div className="about-stat__label">Happy Travelers</div>
              </div>
              <div className="about-stat">
                <div className="about-stat__number">24/7</div>
                <div className="about-stat__label">Support</div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default About;
